import axios from "axios";

const baseURL = `https://autodukan.com/gms`;
// const baseURL = `https://dev.autodukan.com/autodukan/v1`;
// const baseURL =`http://localhost/autodukan_backend`;

export const getCarCompatibilitysVarient = async (id,year) => {
  try {
    const response = await axios.get(
      `${baseURL}/api/customer/compatibility?model=${id}&year=${year}`
    );
    return response.data;
  } catch (error) {
    return error.response.data; 
  }
};


export const getHomeScreenImages = async () => {
  try {
    let response = await axios({
      method: "GET",
      url: `${baseURL}/api/customer/home-slider`,
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const getBrands = async () => {
  try {
    const response = await axios.get(`${baseURL}/api/customer/brands`);
    return response.data;
  } catch (error) {
    console.error("Error fetching subcategorys:", error);
    throw error; // Rethrow the error so it can be handled by the caller
  }
};

export const getCarBrands = async () => {
  try {
    const response = await axios.get(`${baseURL}/api/customer/car_brands`);
    return response.data;
  } catch (error) {
    console.error("Error fetching subcategorys:", error);
    return error.response; // Rethrow the error so it can be handled by the caller
  }
};

export const getCarModels = async (id) => {
  try {
    const response = await axios.get(
      `${baseURL}/api/customer/car_models?brand_id=${id}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching subcategorys:", error);
    return error.response; // Rethrow the error so it can be handled by the caller
  }
};

export const getFeaturedProductList = async () => {
  try {
    const response = await axios.get(
      `${baseURL}/api/customer/feature-product-list`,{
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching feature product list:", error);
    return error.response; // Rethrow the error so it can be handled by the caller
  }
};

export const getCarCompatibilitys = async (id) => {
  try {
    const response = await axios.get(
      `${baseURL}/api/customer/compatibility?model=${id}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching car compatibilty:", error);
    return error.response; // Rethrow the error so it can be handled by the caller
  }
};

export const getCarPartSearch = async (id) => {
  try {
    const response = await axios.get(
      `${baseURL}/api/customer/searchcarproduct?compatibility_group_id=${id}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching car part search:", error);
    throw error; // Rethrow the error so it can be handled by the caller
  }
};

export const getSearch = async (term) => {
  try {
    const response = await axios.get(
      `${baseURL}/api/customer/searchat?term=${term}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching get search:", error);
    return error.response.data; // Rethrow the error so it can be handled by the caller
  }
};

export const callSearchAction = async (url) => {
  try {
    const response = await axios.get(url);
    return response?.data;
  } catch (error) {
    console.error("Error fetching call search:", error);
    return error?.response?.data; // Rethrow the error so it can be handled by the caller
  }
};

export const contacUs = async (data) => {
  try {
    let response = await axios({
      method: "POST",
      url: `${baseURL}/api/customer/contact-detail-save`,
      data: data,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    return error.response.data;
  }
};
